import EventEmitter from 'events';
var eventEmiter = new EventEmitter();
export default eventEmiter;
